import { type RomanApiError, isBadInternetConnectionError } from "@roman/shared/utils/error";
import { useCallback } from "react";
import { environment } from "../utils/environment";

export type Toast = {
  error: (message: string, options?: { description?: string }) => void;
};

const DESCRIPTION = environment.isMobile
  ? "推奨: 安定したネットワーク環境で再度お試しください。\n問題が解決しない場合はアプリを再起動してください。"
  : "推奨: エラーが起きた際は、ブラウザタブを一度消してリロードしてください";

export const useHandleErrorBase = (message = "", toast: Toast = { error: () => {} }) => {
  return useCallback(
    (error: RomanApiError) => {
      if (isBadInternetConnectionError(error)) {
        // toast.error("通信エラー", {
        //   description: "より安定したネットワーク環境で再度お試しください。",
        // });
        return;
      }
      const errorCode = error.status || 400;
      toast.error(`[${errorCode}] ${message}`, {
        description: DESCRIPTION,
      });
    },
    [message, toast.error],
  );
};
